import { podeLogarAuth } from "@/lib/dev-config";

export function logAuthCliente(etapa: string, dados?: unknown): void {
  if (!podeLogarAuth()) return;
  const prefixo = `[auth][cliente][${new Date().toISOString()}] ${etapa}`;
  if (dados === undefined) console.info(prefixo);
  else console.info(prefixo, dados);
}
